import { Route, Switch } from "react-router-dom";
import { useBrowserPageTitle } from "../../shared/hooks/useBrowserPageTitle";
import {
  PAYER_DETAILS_PATH,
  PAYER_DETAILS_REQUIREMENTS_PATH,
  PAYER_ENGAGEMENT_HISTORY_PATH,
  PAYER_ENGAGEMENT_PATH,
  PAYER_HISTORY_PATH,
  PAYERS_PATH,
  PAYERS_REQUIREMENTS_PATH
} from "./paths";
import { RouteArchivedClients } from "./routes/RouteArchivedClients";
import { RouteClientDetails } from "./routes/RouteClientDetails";
import { RouteClients } from "./routes/RouteClients";
import { RoutePayerEngagementDetails } from "./routes/RoutePayerEngagementDetails";
import { RoutePayerEngagementHistory } from "./routes/RoutePayerEngagementHistory";
import { RoutePayerHistory } from "./routes/RoutePayerHistory";
import { RouteRequirementDetails } from "./routes/RouteRequirementDetails";
import { RouteSearchClients } from "./routes/RouteSearchClients";

export const PayersIndex = () => {
  useBrowserPageTitle("Clients");

  return (
    <Switch>
      <Route
        path={`${PAYERS_PATH}/archived`}
        component={RouteArchivedClients}
        exact
      />
      <Route
        path={`${PAYERS_PATH}/search`}
        component={RouteSearchClients}
        exact
      />

      <Route path={PAYERS_REQUIREMENTS_PATH} component={RouteClients} />
      <Route
        path={PAYER_DETAILS_REQUIREMENTS_PATH}
        component={RouteClientDetails}
      />

      <Route
        path={`${PAYERS_PATH}/:payerId/requirement/:requirementId`}
        component={RouteRequirementDetails}
      />

      <Route
        path={PAYER_ENGAGEMENT_HISTORY_PATH}
        component={RoutePayerEngagementHistory}
      />

      <Route
        path={PAYER_ENGAGEMENT_PATH}
        component={RoutePayerEngagementDetails}
      />

      <Route path={PAYER_HISTORY_PATH} component={RoutePayerHistory} />

      <Route path={PAYER_DETAILS_PATH} component={RouteClientDetails} />

      <Route path={PAYERS_PATH} component={RouteClients} />
    </Switch>
  );
};
